import { useState } from 'react';
import Layout from '../../../components/layout/Layout';

export default function GamificacaoLogs() {
  const [filtroTipo, setFiltroTipo] = useState('todos');
  const [filtroOrigem, setFiltroOrigem] = useState('todas');
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');

  // Tipos de log
  const tiposLog = [
    'Ganho de XP',
    'Perda de XP',
    'Ajuste Administrativo',
    'Missão Concluída',
    'Jogo Utilizado',
    'Palpite Enviado',
    'Produto Resgatado',
    'Alteração de Regra',
    'Ação de Administrador',
  ];

  // Origens
  const origens = [
    'Sistema',
    'Administrador',
    'Participante',
    'Integração ERP',
    'API Externa',
  ];

  // Logs
  const logs = [
    {
      id: 1,
      data: '15/01/2024 14:30:25',
      tipo: 'Ganho de XP',
      origem: 'Sistema',
      participante: 'João Silva',
      campanha: 'Campanha Verão 2024',
      descricao: 'Ganhou 100 XP por venda de produto',
      detalhes: 'Produto: Notebook Dell | Valor: R$ 3.500,00',
      usuario_admin: null,
      xp_antes: 4500,
      xp_depois: 4600,
    },
    {
      id: 2,
      data: '15/01/2024 14:15:10',
      tipo: 'Missão Concluída',
      origem: 'Sistema',
      participante: 'Maria Santos',
      campanha: 'Mega Vendas Q1',
      descricao: 'Completou missão "Vendedor Estrela"',
      detalhes: 'Ganhou 500 XP + Distintivo "Vendedor Estrela"',
      usuario_admin: null,
      xp_antes: 3200,
      xp_depois: 3700,
    },
    {
      id: 3,
      data: '15/01/2024 13:45:33',
      tipo: 'Jogo Utilizado',
      origem: 'Participante',
      participante: 'Pedro Costa',
      campanha: 'Ativação Premium',
      descricao: 'Girou a Roleta Premium',
      detalhes: 'Gastou 50 XP | Ganhou prêmio: 200 XP',
      usuario_admin: null,
      xp_antes: 2500,
      xp_depois: 2650,
    },
    {
      id: 4,
      data: '15/01/2024 12:20:15',
      tipo: 'Ajuste Administrativo',
      origem: 'Administrador',
      participante: 'Ana Oliveira',
      campanha: 'Campanha Verão 2024',
      descricao: 'Ajuste manual de XP',
      detalhes: 'Motivo: Correção de erro no sistema',
      usuario_admin: 'Admin',
      xp_antes: 1800,
      xp_depois: 2300,
    },
    {
      id: 5,
      data: '15/01/2024 11:30:45',
      tipo: 'Produto Resgatado',
      origem: 'Participante',
      participante: 'Carlos Souza',
      campanha: 'Serviços Plus',
      descricao: 'Resgatou produto com XP',
      detalhes: 'Produto: Mouse Logitech | Custo: 500 XP',
      usuario_admin: null,
      xp_antes: 5500,
      xp_depois: 5000,
    },
    {
      id: 6,
      data: '15/01/2024 10:15:20',
      tipo: 'Alteração de Regra',
      origem: 'Administrador',
      participante: null,
      campanha: 'Todas',
      descricao: 'Alterou XP de Venda de Produto',
      detalhes: 'De: 80 XP → Para: 100 XP',
      usuario_admin: 'Admin',
      xp_antes: null,
      xp_depois: null,
    },
    {
      id: 7,
      data: '15/01/2024 09:45:10',
      tipo: 'Palpite Enviado',
      origem: 'Participante',
      participante: 'Lucas Ferreira',
      campanha: 'Todas',
      descricao: 'Enviou palpite na Copa',
      detalhes: 'Partida: Brasil x Argentina | Palpite: 2x1 | Gastou 10 XP',
      usuario_admin: null,
      xp_antes: 1200,
      xp_depois: 1190,
    },
    {
      id: 8,
      data: '14/01/2024 18:30:55',
      tipo: 'Ganho de XP',
      origem: 'Integração ERP',
      participante: 'Juliana Lima',
      campanha: 'Campanha Verão 2024',
      descricao: 'Ganhou 150 XP por prestação de serviço',
      detalhes: 'Serviço: Consultoria em TI | Valor: R$ 5.000,00',
      usuario_admin: null,
      xp_antes: 3800,
      xp_depois: 3950,
    },
  ];

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Logs & Auditoria</h1>
            <p className="text-sm text-gray-600 mt-1">Histórico completo de ações da gamificação</p>
          </div>
          <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">
            <i className="ri-download-line mr-2"></i>
            Exportar Logs
          </button>
        </div>

        {/* Filtros */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Log</label>
              <select
                value={filtroTipo}
                onChange={(e) => setFiltroTipo(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              >
                <option value="todos">Todos os Tipos</option>
                {tiposLog.map((tipo, index) => (
                  <option key={index} value={tipo}>{tipo}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Origem</label>
              <select
                value={filtroOrigem}
                onChange={(e) => setFiltroOrigem(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              >
                <option value="todas">Todas as Origens</option>
                {origens.map((origem, index) => (
                  <option key={index} value={origem}>{origem}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Data Início</label>
              <input
                type="date"
                value={dataInicio}
                onChange={(e) => setDataInicio(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Data Fim</label>
              <input
                type="date"
                value={dataFim}
                onChange={(e) => setDataFim(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Buscar</label>
              <input
                type="text"
                placeholder="Participante, campanha..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            </div>
          </div>
          <div className="mt-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-600">Total de registros:</span>
              <span className="text-sm font-bold text-gray-900">{logs.length}</span>
            </div>
            <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium whitespace-nowrap">
              <i className="ri-filter-off-line mr-2"></i>
              Limpar Filtros
            </button>
          </div>
        </div>

        {/* Timeline de Logs */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Timeline de Atividades</h2>
          <div className="space-y-4">
            {logs.map((log) => (
              <div key={log.id} className="relative pl-8 pb-4 border-l-2 border-gray-200 last:border-l-0 last:pb-0">
                {/* Ícone do tipo de log */}
                <div className={`absolute -left-3 top-0 w-6 h-6 rounded-full flex items-center justify-center ${
                  log.tipo === 'Ganho de XP' ? 'bg-green-500' :
                  log.tipo === 'Perda de XP' ? 'bg-red-500' :
                  log.tipo === 'Ajuste Administrativo' ? 'bg-yellow-500' :
                  log.tipo === 'Missão Concluída' ? 'bg-purple-500' :
                  log.tipo === 'Jogo Utilizado' ? 'bg-blue-500' :
                  log.tipo === 'Palpite Enviado' ? 'bg-indigo-500' :
                  log.tipo === 'Produto Resgatado' ? 'bg-pink-500' :
                  log.tipo === 'Alteração de Regra' ? 'bg-orange-500' :
                  'bg-gray-500'
                }`}>
                  <i className={`text-white text-xs ${
                    log.tipo === 'Ganho de XP' ? 'ri-arrow-up-line' :
                    log.tipo === 'Perda de XP' ? 'ri-arrow-down-line' :
                    log.tipo === 'Ajuste Administrativo' ? 'ri-edit-line' :
                    log.tipo === 'Missão Concluída' ? 'ri-trophy-line' :
                    log.tipo === 'Jogo Utilizado' ? 'ri-gamepad-line' :
                    log.tipo === 'Palpite Enviado' ? 'ri-football-line' :
                    log.tipo === 'Produto Resgatado' ? 'ri-gift-line' :
                    log.tipo === 'Alteração de Regra' ? 'ri-settings-3-line' :
                    'ri-information-line'
                  }`}></i>
                </div>

                {/* Conteúdo do log */}
                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <div className="flex items-start justify-between mb-2">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                          log.tipo === 'Ganho de XP' ? 'bg-green-100 text-green-800' :
                          log.tipo === 'Perda de XP' ? 'bg-red-100 text-red-800' :
                          log.tipo === 'Ajuste Administrativo' ? 'bg-yellow-100 text-yellow-800' :
                          log.tipo === 'Missão Concluída' ? 'bg-purple-100 text-purple-800' :
                          log.tipo === 'Jogo Utilizado' ? 'bg-blue-100 text-blue-800' :
                          log.tipo === 'Palpite Enviado' ? 'bg-indigo-100 text-indigo-800' :
                          log.tipo === 'Produto Resgatado' ? 'bg-pink-100 text-pink-800' :
                          log.tipo === 'Alteração de Regra' ? 'bg-orange-100 text-orange-800' :
                          'bg-gray-100 text-gray-800'
                        }`}>
                          {log.tipo}
                        </span>
                        <span className="inline-flex items-center px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-medium">
                          {log.origem}
                        </span>
                      </div>
                      <p className="text-sm font-semibold text-gray-900">{log.descricao}</p>
                      <p className="text-xs text-gray-600 mt-1">{log.detalhes}</p>
                    </div>
                    <span className="text-xs text-gray-500 whitespace-nowrap ml-4">{log.data}</span>
                  </div>

                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-3 pt-3 border-t border-gray-200">
                    {log.participante && (
                      <div>
                        <p className="text-xs text-gray-600">Participante</p>
                        <p className="text-sm font-medium text-gray-900">{log.participante}</p>
                      </div>
                    )}
                    {log.campanha && (
                      <div>
                        <p className="text-xs text-gray-600">Campanha</p>
                        <p className="text-sm font-medium text-gray-900">{log.campanha}</p>
                      </div>
                    )}
                    {log.xp_antes !== null && (
                      <div>
                        <p className="text-xs text-gray-600">XP Antes</p>
                        <p className="text-sm font-bold text-gray-700">{log.xp_antes} XP</p>
                      </div>
                    )}
                    {log.xp_depois !== null && (
                      <div>
                        <p className="text-xs text-gray-600">XP Depois</p>
                        <p className="text-sm font-bold text-teal-600">{log.xp_depois} XP</p>
                      </div>
                    )}
                    {log.usuario_admin && (
                      <div>
                        <p className="text-xs text-gray-600">Administrador</p>
                        <p className="text-sm font-medium text-gray-900">{log.usuario_admin}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Paginação */}
        <div className="flex items-center justify-between">
          <p className="text-sm text-gray-600">
            Mostrando <span className="font-medium">1-8</span> de <span className="font-medium">8</span> registros
          </p>
          <div className="flex items-center gap-2">
            <button className="px-3 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">
              <i className="ri-arrow-left-s-line"></i>
              Anterior
            </button>
            <button className="px-3 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">
              1
            </button>
            <button className="px-3 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">
              Próximo
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
